/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVialPlus: {
  name: 'vial-plus';
  data: string;
} = {
  name: 'vial-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 2a1 1 0 0 0 0 2h1v14a4 4 0 0 0 8 0V4h1a1 1 0 1 0 0-2H3Zm3 2v4h4V4H6Zm0 6h4v8a2 2 0 1 1-4 0v-8Zm12-2a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2V9a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
